import { createMuiTheme } from '@material-ui/core/styles';
import 'typeface-pt-sans';

const dark = createMuiTheme({
  containerMarginBase: marginToAdd => `calc(100vw - 100% + ${marginToAdd || '0px'})`,
  palette: {
    type: 'dark',
    primary: {
      light: '#b3e1f5',
      main: '#009bdf',
      dark: '#007fd2',
    },
    secondary: {
      light: '#bdcbe3',
      main: '#2250A0',
      dark: '#143784',
    },
    common: {
      white: '#202020',
      black: '#f9ffff',
      shaded: 'rgba(0,0,0,0.04)',
    },
    footer: {
      default: '#555555',
    },
  },
  typography: {
    fontFamily: 'PT Sans',
    // useNextVariants: true,
  },
  overrides: {
    MuiList: {
      padding: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  },
});

export default dark;
